import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString1h6jjoch8cjt8 as toString_0,
  newThrowablezl37abp36p5f as newThrowable,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  VOID3gxj6tk5isa35 as VOID,
  isInterface3d6p8outrmvmk as isInterface,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
  intercepted2ogpsikxxj4u0 as intercepted,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  returnIfSuspendedqak8u4r448cu as returnIfSuspended,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  convertToInty04h231mmjoh as convertToInt,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalStateException_init_$Init$3ccqbeatlpw5c as IllegalStateException_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  replace3le3ie7l9k8aq as replace,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get_ONEazvfdh9ju3d4 as get_ONE,
  toString1pkumu07cwy4m as toString_1,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  subtract2orl8z9upxd9l as subtract,
  closeFinally1sadm0w9gt3u4 as closeFinally,
  EmptyCoroutineContext_instance2qpebg1xogbvt as EmptyCoroutineContext_instance,
  Continuation1aa2oekvx7jm7 as Continuation,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  CancellationException_init_$Create$1muhzgve35v78 as CancellationException_init_$Create$,
  CancellationException3b36o9qz53rgr as CancellationException,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  listOf1jh22dvmctj1r as listOf,
  StringBuilder_init_$Create$2ujvu6cqvzuyn as StringBuilder_init_$Create$,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  encodeToByteArray22651fhg4p67t as encodeToByteArray,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toByte4i43936u611k as toByte,
  decodeToString1x4faah2liw2p as decodeToString,
  setOf45ia9pnfhe90 as setOf,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
} from './kotlin-kotlin-stdlib.mjs';
import {
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
  startCoroutineCancellable18shtfwdieib as startCoroutineCancellable,
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
  cancel1xim2hrvjmwpn as cancel,
  CopyableThrowable1mvc99jcyvivf as CopyableThrowable,
  Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance,
} from './kotlinx-coroutines-core.mjs';
import {
  Buffergs925ekssbch as Buffer,
  IOException_init_$Create$1wkk79fgwuoz2 as IOException_init_$Create$,
  indexOf29nspdgx2e3ap as indexOf,
  EOFException_init_$Create$2ki37nn86l2yt as EOFException_init_$Create$,
  readStringo8i62qxt5m4m as readString,
  readByteString2hnsbql6t4ads as readByteString,
  readString2nvggcfaijfhd as readString_0,
  IOException1wyutdmfe71nu as IOException,
  IOException_init_$Init$1s6rw4r2mxxsm as IOException_init_$Init$,
  IOException_init_$Create$2jyze3554lamk as IOException_init_$Create$_0,
  readByteArray1fhzfwi2j014k as readByteArray,
  readString3v6duspiz33tv as readString_1,
  writeString33ca4btrgctw7 as writeString,
  IOException_init_$Init$3tijvyh8jladu as IOException_init_$Init$_0,
  readByteArray1ri21h2rciakw as readByteArray_0,
} from './kotlinx-io-kotlinx-io-core.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import { decodeToString2ede220pr5xir as decodeToString_0 } from './kotlinx-io-kotlinx-io-bytestring.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject(Empty, 'Empty');
initMetadataForClass(Closed, 'Closed');
function resume() {
  return this.l2j().o8(Companion_getInstance().i2j_1);
}
function resume_0(throwable) {
  var tmp = this.l2j();
  var tmp_0;
  if (throwable == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(throwable));
    tmp_0 = new Result(tmp$ret$2);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp.o8(tmp1_elvis_lhs == null ? Companion_getInstance().i2j_1 : tmp1_elvis_lhs.cn_1);
}
initMetadataForInterface(Task, 'Task');
initMetadataForClass(Read, 'Read', VOID, VOID, [Task]);
initMetadataForClass(Write, 'Write', VOID, VOID, [Task]);
initMetadataForCoroutine($awaitContentCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($flushCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($flushAndCloseCOROUTINE$, CoroutineImpl);
function awaitContent$default(min, $completion, $super) {
  min = min === VOID ? 1 : min;
  return $super === VOID ? this.s2l(min, $completion) : $super.s2l.call(this, min, $completion);
}
initMetadataForInterface(ByteReadChannel_1, 'ByteReadChannel', VOID, VOID, VOID, [1]);
function get_autoFlush() {
  return false;
}
initMetadataForInterface(ByteWriteChannel, 'ByteWriteChannel', VOID, VOID, VOID, [0]);
initMetadataForClass(ByteChannel, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel_1, ByteWriteChannel], [1, 0]);
initMetadataForClass(ConcurrentIOException, 'ConcurrentIOException', VOID, IllegalStateException);
initMetadataForCoroutine($findNextCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($advanceToNextPotentialMatchCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($checkFullMatchCOROUTINE$, CoroutineImpl);
initMetadataForClass(ByteChannelScanner, 'ByteChannelScanner', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(ByteReadChannel$Companion$Empty$1, VOID, VOID, VOID, [ByteReadChannel_1], [1]);
initMetadataForCompanion(Companion_0);
initMetadataForCoroutine($readRemainingCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($discardCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($readAvailableCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($toByteArrayCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($copyToCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($skipIfFoundCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($readPacketCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($readUTF8LineToCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($readBufferCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($peekCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($flushIfNeededCOROUTINE$, CoroutineImpl);
initMetadataForClass(WriterJob, 'WriterJob');
initMetadataForClass(WriterScope, 'WriterScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(NO_CALLBACK$1, VOID, VOID, VOID, [Continuation]);
initMetadataForFunctionReference(ByteWriteChannel$flushAndClose$ref, VOID, VOID, [0]);
initMetadataForLambda(writer$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(CloseToken, 'CloseToken');
initMetadataForCoroutine($awaitContentCOROUTINE$_0, CoroutineImpl);
initMetadataForClass(CountedByteReadChannel, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel_1], [1]);
initMetadataForClass(ClosedByteChannelException, 'ClosedByteChannelException', ClosedByteChannelException, IOException);
initMetadataForClass(ClosedReadChannelException, 'ClosedReadChannelException', ClosedReadChannelException, ClosedByteChannelException);
initMetadataForClass(ClosedWriteChannelException, 'ClosedWriteChannelException', ClosedWriteChannelException, ClosedByteChannelException);
initMetadataForCompanion(Companion_1);
initMetadataForClass(LineEndingMode, 'LineEndingMode');
initMetadataForClass(SourceByteReadChannel, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel_1], [1]);
initMetadataForClass(MalformedInputException, 'MalformedInputException', VOID, IOException);
initMetadataForClass(TooLongLineException, 'TooLongLineException', VOID, MalformedInputException);
function close() {
  this.t20();
}
initMetadataForInterface(ObjectPool, 'ObjectPool', VOID, VOID, [AutoCloseable]);
initMetadataForClass(DefaultPool, 'DefaultPool', VOID, VOID, [ObjectPool]);
initMetadataForClass(ByteArrayPool$1, VOID, VOID, DefaultPool);
initMetadataForClass(NoPoolImpl, 'NoPoolImpl', VOID, VOID, [ObjectPool]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(Charset, 'Charset');
initMetadataForObject(Charsets, 'Charsets');
initMetadataForClass(CharsetDecoder, 'CharsetDecoder');
initMetadataForClass(CharsetEncoder, 'CharsetEncoder');
initMetadataForClass(CharsetImpl, 'CharsetImpl', VOID, Charset);
initMetadataForClass(CharsetEncoderImpl, 'CharsetEncoderImpl', VOID, CharsetEncoder);
initMetadataForClass(CharsetDecoderImpl, 'CharsetDecoderImpl', VOID, CharsetDecoder);
initMetadataForClass(toKtor$1);
initMetadataForClass(TextDecoderFallback, 'TextDecoderFallback');
//endregion
function Companion() {
  Companion_instance_0 = this;
  this.h2j_1 = new Closed(null);
  var tmp = this;
  // Inline function 'kotlin.Companion.success' call
  tmp.i2j_1 = _Result___init__impl__xyqfz8(Unit_instance);
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function Empty() {
}
protoOf(Empty).toString = function () {
  return 'Empty';
};
protoOf(Empty).hashCode = function () {
  return -231472095;
};
protoOf(Empty).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Empty))
    return false;
  return true;
};
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
function Closed(cause) {
  this.j2j_1 = cause;
}
protoOf(Closed).toString = function () {
  return 'Closed(cause=' + toString(this.j2j_1) + ')';
};
protoOf(Closed).hashCode = function () {
  return this.j2j_1 == null ? 0 : hashCode(this.j2j_1);
};
protoOf(Closed).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Closed))
    return false;
  if (!equals(this.j2j_1, other.j2j_1))
    return false;
  return true;
};
function Task() {
}
function Read(continuation) {
  this.p2j_1 = continuation;
  this.q2j_1 = null;
  if (get_DEVELOPMENT_MODE()) {
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = newThrowable('ReadTask 0x' + toString_0(hashCode(this.p2j_1), 16));
    stackTraceToString(this_0);
    tmp.q2j_1 = this_0;
  }
}
protoOf(Read).l2j = function () {
  return this.p2j_1;
};
protoOf(Read).k2j = function () {
  return this.q2j_1;
};
protoOf(Read).m2j = function () {
  return 'read';
};
function Write(continuation) {
  this.r2j_1 = continuation;
  this.s2j_1 = null;
  if (get_DEVELOPMENT_MODE()) {
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = newThrowable('WriteTask 0x' + toString_0(hashCode(this.r2j_1), 16));
    stackTraceToString(this_0);
    tmp.s2j_1 = this_0;
  }
}
protoOf(Write).l2j = function () {
  return this.r2j_1;
};
protoOf(Write).k2j = function () {
  return this.s2j_1;
};
protoOf(Write).m2j = function () {
  return 'write';
};
function moveFlushToReadBuffer($this) {
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  $this.w2j_1;
  $this.u2j_1.y1u($this.y2j_1);
  $this.v2j_1 = 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = $this.x2j_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Write) {
    tmp = $this.x2j_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.n2j();
  }
}
function closeSlot($this, cause) {
  var closeContinuation = !(cause == null) ? new Closed(cause) : Companion_getInstance().h2j_1;
  var continuation = $this.x2j_1.atomicfu$getAndSet(closeContinuation);
  if (isInterface(continuation, Task)) {
    continuation.o2j(cause);
  }
}
function ClosedReadChannelException$_init_$ref_ix0089() {
  var l = function (p0) {
    return new ClosedReadChannelException(p0);
  };
  l.callableName = '<init>';
  return l;
}
function ClosedWriteChannelException$_init_$ref_ef15ty() {
  var l = function (p0) {
    return new ClosedWriteChannelException(p0);
  };
  l.callableName = '<init>';
  return l;
}
function $awaitContentCOROUTINE$(_this__u8e3s4, min, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.j2k_1 = _this__u8e3s4;
  this.k2k_1 = min;
}
protoOf($awaitContentCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          rethrowCloseCauseIfNeeded(this.j2k_1);
          if (this.j2k_1.y2j_1.o() >= fromInt(this.k2k_1))
            return true;
          this.l2k_1 = this.j2k_1;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!(add(numberToLong(this.j2k_1.v2j_1), this.j2k_1.y2j_1.o()) < fromInt(this.k2k_1) && this.j2k_1.a2k_1.kotlinx$atomicfu$value == null)) {
            this.d8_1 = 3;
            continue $sm;
          }

          this.d8_1 = 2;
          var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
          cancellable.w21();
          var tmp0 = this.l2k_1;
          var tmp2 = new Read(cancellable);
          l$ret$1: do {
            var previous = tmp0.x2j_1.kotlinx$atomicfu$value;
            if (!(previous instanceof Closed)) {
              if (!tmp0.x2j_1.atomicfu$compareAndSet(previous, tmp2)) {
                tmp2.n2j();
                break l$ret$1;
              }
            }
            if (previous instanceof Read) {
              previous.o2j(new ConcurrentIOException(tmp2.m2j(), previous.k2j()));
            } else {
              if (isInterface(previous, Task)) {
                previous.n2j();
              } else {
                if (previous instanceof Closed) {
                  tmp2.o2j(previous.j2j_1);
                  break l$ret$1;
                } else {
                  if (!equals(previous, Empty_instance)) {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
            if (!(add(numberToLong(this.j2k_1.v2j_1), this.j2k_1.y2j_1.o()) < fromInt(this.k2k_1) && this.j2k_1.a2k_1.kotlinx$atomicfu$value == null)) {
              var current = tmp0.x2j_1.kotlinx$atomicfu$value;
              var tmp_0;
              if (current instanceof Read) {
                tmp_0 = tmp0.x2j_1.atomicfu$compareAndSet(current, Empty_instance);
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                current.n2j();
              }
            }
          }
           while (false);
          suspendResult = returnIfSuspended(cancellable.e22(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          if (this.j2k_1.y2j_1.o() < 1048576n) {
            moveFlushToReadBuffer(this.j2k_1);
          }

          return this.j2k_1.y2j_1.o() >= fromInt(this.k2k_1);
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $flushCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.u2k_1 = _this__u8e3s4;
}
protoOf($flushCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          rethrowCloseCauseIfNeeded(this.u2k_1);
          this.u2k_1.w2k();
          if (this.u2k_1.v2j_1 < 1048576)
            return Unit_instance;
          this.v2k_1 = this.u2k_1;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!(this.u2k_1.v2j_1 >= 1048576 && this.u2k_1.a2k_1.kotlinx$atomicfu$value == null)) {
            this.d8_1 = 3;
            continue $sm;
          }

          this.d8_1 = 2;
          var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
          cancellable.w21();
          var tmp0 = this.v2k_1;
          var tmp2 = new Write(cancellable);
          l$ret$1: do {
            var previous = tmp0.x2j_1.kotlinx$atomicfu$value;
            if (!(previous instanceof Closed)) {
              if (!tmp0.x2j_1.atomicfu$compareAndSet(previous, tmp2)) {
                tmp2.n2j();
                break l$ret$1;
              }
            }
            if (previous instanceof Write) {
              previous.o2j(new ConcurrentIOException(tmp2.m2j(), previous.k2j()));
            } else {
              if (isInterface(previous, Task)) {
                previous.n2j();
              } else {
                if (previous instanceof Closed) {
                  tmp2.o2j(previous.j2j_1);
                  break l$ret$1;
                } else {
                  if (!equals(previous, Empty_instance)) {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
            if (!(this.u2k_1.v2j_1 >= 1048576 && this.u2k_1.a2k_1.kotlinx$atomicfu$value == null)) {
              var current = tmp0.x2j_1.kotlinx$atomicfu$value;
              var tmp_0;
              if (current instanceof Write) {
                tmp_0 = tmp0.x2j_1.atomicfu$compareAndSet(current, Empty_instance);
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                current.n2j();
              }
            }
          }
           while (false);
          suspendResult = returnIfSuspended(cancellable.e22(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $flushAndCloseCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.f2l_1 = _this__u8e3s4;
}
protoOf($flushAndCloseCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          var this_0 = this.f2l_1;
          this.e8_1 = 2;
          var tmp_0 = this;
          tmp_0.h2l_1 = Companion_instance;
          this.d8_1 = 1;
          suspendResult = this_0.i2l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp_1 = this;
          this.h2l_1;
          tmp_1.g2l_1 = _Result___init__impl__xyqfz8(Unit_instance);
          this.e8_1 = 4;
          this.d8_1 = 3;
          continue $sm;
        case 2:
          this.e8_1 = 4;
          var tmp_2 = this.g8_1;
          if (tmp_2 instanceof Error) {
            var e = this.g8_1;
            var tmp_3 = this;
            tmp_3.g2l_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.d8_1 = 3;
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 3:
          this.e8_1 = 4;
          if (!this.f2l_1.a2k_1.atomicfu$compareAndSet(null, get_CLOSED()))
            return Unit_instance;
          closeSlot(this.f2l_1, null);
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.e8_1 === 4) {
        throw e_0;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e_0;
      }
    }
   while (true);
};
function ByteChannel(autoFlush) {
  autoFlush = autoFlush === VOID ? false : autoFlush;
  this.t2j_1 = autoFlush;
  this.u2j_1 = new Buffer();
  this.v2j_1 = 0;
  this.w2j_1 = new Object();
  this.x2j_1 = atomic$ref$1(Empty_instance);
  this.y2j_1 = new Buffer();
  this.z2j_1 = new Buffer();
  this.a2k_1 = atomic$ref$1(null);
}
protoOf(ByteChannel).j2l = function () {
  return this.t2j_1;
};
protoOf(ByteChannel).k2l = function () {
  var tmp0_safe_receiver = this.a2k_1.kotlinx$atomicfu$value;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.m2l(ClosedReadChannelException$_init_$ref_ix0089());
  }
  if (this.y2j_1.v1t()) {
    moveFlushToReadBuffer(this);
  }
  return this.y2j_1;
};
protoOf(ByteChannel).n2l = function () {
  if (this.o2l()) {
    var tmp0_safe_receiver = this.a2k_1.kotlinx$atomicfu$value;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.m2l(ClosedWriteChannelException$_init_$ref_ef15ty());
    }
    if (tmp == null)
      throw new ClosedWriteChannelException();
  }
  return this.z2j_1;
};
protoOf(ByteChannel).p2l = function () {
  var tmp0_safe_receiver = this.a2k_1.kotlinx$atomicfu$value;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2l();
};
protoOf(ByteChannel).o2l = function () {
  return !(this.a2k_1.kotlinx$atomicfu$value == null);
};
protoOf(ByteChannel).r2l = function () {
  return !(this.p2l() == null) || (this.o2l() && this.v2j_1 === 0 && this.y2j_1.v1t());
};
protoOf(ByteChannel).s2l = function (min, $completion) {
  var tmp = new $awaitContentCOROUTINE$(this, min, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(ByteChannel).i2l = function ($completion) {
  var tmp = new $flushCOROUTINE$(this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(ByteChannel).w2k = function () {
  if (this.z2j_1.v1t())
    return Unit_instance;
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  this.w2j_1;
  var count = convertToInt(this.z2j_1.o());
  this.u2j_1.m1v(this.z2j_1);
  this.v2j_1 = this.v2j_1 + count | 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = this.x2j_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Read) {
    tmp = this.x2j_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.n2j();
  }
};
protoOf(ByteChannel).i3 = function () {
  this.w2k();
  if (!this.a2k_1.atomicfu$compareAndSet(null, get_CLOSED()))
    return Unit_instance;
  closeSlot(this, null);
};
protoOf(ByteChannel).u2l = function ($completion) {
  var tmp = new $flushAndCloseCOROUTINE$(this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(ByteChannel).v2l = function (cause) {
  if (!(this.a2k_1.kotlinx$atomicfu$value == null))
    return Unit_instance;
  var closedToken = new CloseToken(cause);
  this.a2k_1.atomicfu$compareAndSet(null, closedToken);
  var wrappedCause = closedToken.q2l();
  closeSlot(this, wrappedCause);
};
protoOf(ByteChannel).toString = function () {
  return 'ByteChannel[' + hashCode(this) + ']';
};
function ConcurrentIOException(taskName, cause) {
  cause = cause === VOID ? null : cause;
  IllegalStateException_init_$Init$('Concurrent ' + taskName + ' attempts', cause, this);
  captureStack(this, ConcurrentIOException);
}
function ByteReadChannel(content, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? content.length : length;
  // Inline function 'kotlin.also' call
  var this_0 = new Buffer();
  this_0.e1v(content, offset, offset + length | 0);
  var source = this_0;
  return ByteReadChannel_0(source);
}
function ByteReadChannel_0(source) {
  return new SourceByteReadChannel(source);
}
function buildPartialMatchTable($this) {
  var table = new Int32Array($this.x2l_1.o());
  var j = 0;
  var inductionVariable = 1;
  var last = $this.x2l_1.o();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while (j > 0 && !($this.x2l_1.p(i) === $this.x2l_1.p(j))) {
        j = table[j - 1 | 0];
      }
      if ($this.x2l_1.p(i) === $this.x2l_1.p(j)) {
        j = j + 1 | 0;
      }
      table[i] = j;
    }
     while (inductionVariable < last);
  return table;
}
function advanceToNextPotentialMatch($this, $completion) {
  var tmp = new $advanceToNextPotentialMatchCOROUTINE$($this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function checkFullMatch($this, $completion) {
  var tmp = new $checkFullMatchCOROUTINE$($this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function checkBounds($this, extra) {
  if (add($this.d2m_1, extra) > $this.z2l_1) {
    throw IOException_init_$Create$('Limit of ' + $this.z2l_1.toString() + ' bytes exceeded ' + ('while searching for "' + toSingleLineString($this, $this.x2l_1) + '"'));
  }
}
function toSingleLineString($this, _this__u8e3s4) {
  return replace(decodeToString_0(_this__u8e3s4), '\n', '\\n');
}
function $findNextCOROUTINE$(_this__u8e3s4, ignoreMissing, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.i2n_1 = _this__u8e3s4;
  this.j2n_1 = ignoreMissing;
}
protoOf($findNextCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 9;
          this.i2n_1.d2m_1 = 0n;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.i2n_1.a2m_1.v1t()) {
            this.k2n_1 = true;
            this.d8_1 = 3;
            continue $sm;
          } else {
            this.d8_1 = 2;
            suspendResult = this.i2n_1.w2l_1.t2l(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 2:
          this.k2n_1 = suspendResult;
          this.d8_1 = 3;
          continue $sm;
        case 3:
          if (!this.k2n_1) {
            this.d8_1 = 7;
            continue $sm;
          }

          this.d8_1 = 4;
          suspendResult = advanceToNextPotentialMatch(this.i2n_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.d8_1 = 5;
          suspendResult = checkFullMatch(this.i2n_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          if (suspendResult) {
            return this.i2n_1.d2m_1;
          } else {
            this.d8_1 = 6;
            continue $sm;
          }

        case 6:
          this.d8_1 = 1;
          continue $sm;
        case 7:
          if (!this.j2n_1) {
            throw IOException_init_$Create$('Expected "' + toSingleLineString(this.i2n_1, this.i2n_1.x2l_1) + '" but encountered end of input');
          }

          this.i2n_1.d2m_1 = add(this.i2n_1.d2m_1, this.i2n_1.c2m_1.y1u(this.i2n_1.y2l_1.n2l()));
          this.d8_1 = 8;
          suspendResult = this.i2n_1.y2l_1.i2l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 8:
          return this.i2n_1.d2m_1;
        case 9:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 9) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $advanceToNextPotentialMatchCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n2m_1 = _this__u8e3s4;
}
protoOf($advanceToNextPotentialMatchCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 8;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.n2m_1.a2m_1.v1t()) {
            this.o2m_1 = true;
            this.d8_1 = 3;
            continue $sm;
          } else {
            this.d8_1 = 2;
            suspendResult = this.n2m_1.w2l_1.t2l(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 2:
          this.o2m_1 = suspendResult;
          this.d8_1 = 3;
          continue $sm;
        case 3:
          if (!this.o2m_1) {
            this.d8_1 = 7;
            continue $sm;
          }

          var nextMatch = indexOf(this.n2m_1.a2m_1, this.n2m_1.x2l_1.p(0));
          if (nextMatch === -1n) {
            var tmp_0 = this.n2m_1.a2m_1;
            checkBounds(this.n2m_1, (tmp_0 instanceof Buffer ? tmp_0 : THROW_CCE()).o());
            this.n2m_1.d2m_1 = add(this.n2m_1.d2m_1, this.n2m_1.a2m_1.y1u(this.n2m_1.y2l_1.n2l()));
            this.d8_1 = 5;
            suspendResult = flushIfNeeded(this.n2m_1.y2l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            checkBounds(this.n2m_1, nextMatch);
            var tmp_1 = this.n2m_1;
            var tmp_2 = this.n2m_1.d2m_1;
            var tmp_3 = this.n2m_1.y2l_1.n2l();
            tmp_1.d2m_1 = add(tmp_2, this.n2m_1.a2m_1.v1u(tmp_3 instanceof Buffer ? tmp_3 : THROW_CCE(), nextMatch));
            this.d8_1 = 4;
            suspendResult = flushIfNeeded(this.n2m_1.y2l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 4:
          return Unit_instance;
        case 5:
          this.d8_1 = 6;
          continue $sm;
        case 6:
          this.d8_1 = 1;
          continue $sm;
        case 7:
          return Unit_instance;
        case 8:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 8) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $checkFullMatchCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.x2m_1 = _this__u8e3s4;
}
protoOf($checkFullMatchCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 8;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.x2m_1.a2m_1.v1t()) {
            this.z2m_1 = true;
            this.d8_1 = 3;
            continue $sm;
          } else {
            this.d8_1 = 2;
            suspendResult = this.x2m_1.w2l_1.t2l(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 2:
          this.z2m_1 = suspendResult;
          this.d8_1 = 3;
          continue $sm;
        case 3:
          if (!this.z2m_1) {
            this.d8_1 = 7;
            continue $sm;
          }

          this.y2m_1 = this.x2m_1.a2m_1.y1t();
          if (this.x2m_1.e2m_1 > 0 && !(this.y2m_1 === this.x2m_1.x2l_1.p(this.x2m_1.e2m_1))) {
            var oldMatchIndex = this.x2m_1.e2m_1;
            while (this.x2m_1.e2m_1 > 0 && !(this.y2m_1 === this.x2m_1.x2l_1.p(this.x2m_1.e2m_1))) {
              this.x2m_1.e2m_1 = this.x2m_1.b2m_1[this.x2m_1.e2m_1 - 1 | 0];
            }
            var retained = fromInt(oldMatchIndex - this.x2m_1.e2m_1 | 0);
            checkBounds(this.x2m_1, retained);
            var tmp_0 = this.x2m_1;
            var tmp_1 = this.x2m_1.d2m_1;
            var tmp_2 = this.x2m_1.y2l_1.n2l();
            tmp_0.d2m_1 = add(tmp_1, this.x2m_1.c2m_1.v1u(tmp_2 instanceof Buffer ? tmp_2 : THROW_CCE(), retained));
            if (this.x2m_1.e2m_1 === 0 && !(this.y2m_1 === this.x2m_1.x2l_1.p(this.x2m_1.e2m_1))) {
              this.d8_1 = 6;
              suspendResult = writeByte(this.x2m_1.y2l_1, this.y2m_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.d8_1 = 4;
              continue $sm;
            }
          } else {
            this.d8_1 = 5;
            continue $sm;
          }

        case 4:
          this.d8_1 = 5;
          continue $sm;
        case 5:
          this.x2m_1.e2m_1 = this.x2m_1.e2m_1 + 1 | 0;
          if (this.x2m_1.e2m_1 === this.x2m_1.x2l_1.o()) {
            return true;
          }

          this.x2m_1.c2m_1.n1v(this.y2m_1);
          this.d8_1 = 1;
          continue $sm;
        case 6:
          var _unary__edvuaz = this.x2m_1.d2m_1;
          this.x2m_1.d2m_1 = add(_unary__edvuaz, get_ONE());
          return false;
        case 7:
          return false;
        case 8:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 8) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function ByteChannelScanner(channel, matchString, writeChannel, limit) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  this.w2l_1 = channel;
  this.x2l_1 = matchString;
  this.y2l_1 = writeChannel;
  this.z2l_1 = limit;
  // Inline function 'kotlin.require' call
  if (!(this.x2l_1.o() > 0)) {
    var message = 'Empty match string not permitted for scanning';
    throw IllegalArgumentException_init_$Create$(toString_1(message));
  }
  this.a2m_1 = this.w2l_1.k2l();
  this.b2m_1 = buildPartialMatchTable(this);
  this.c2m_1 = new Buffer();
  this.d2m_1 = 0n;
  this.e2m_1 = 0;
}
protoOf(ByteChannelScanner).l2n = function (ignoreMissing, $completion) {
  var tmp = new $findNextCOROUTINE$(this, ignoreMissing, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
function ByteReadChannel$Companion$Empty$1() {
  this.m2n_1 = null;
  this.n2n_1 = new Buffer();
}
protoOf(ByteReadChannel$Companion$Empty$1).p2l = function () {
  return this.m2n_1;
};
protoOf(ByteReadChannel$Companion$Empty$1).r2l = function () {
  return true;
};
protoOf(ByteReadChannel$Companion$Empty$1).k2l = function () {
  return this.n2n_1;
};
protoOf(ByteReadChannel$Companion$Empty$1).s2l = function (min, $completion) {
  return false;
};
protoOf(ByteReadChannel$Companion$Empty$1).v2l = function (cause) {
};
function Companion_0() {
  Companion_instance_1 = this;
  var tmp = this;
  tmp.o2n_1 = new ByteReadChannel$Companion$Empty$1();
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 == null)
    new Companion_0();
  return Companion_instance_1;
}
function ByteReadChannel_1() {
}
function cancel_0(_this__u8e3s4) {
  _this__u8e3s4.v2l(IOException_init_$Create$('Channel was cancelled'));
}
function readRemaining(_this__u8e3s4, $completion) {
  var tmp = new $readRemainingCOROUTINE$(_this__u8e3s4, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function discard(_this__u8e3s4, max, $completion) {
  max = max === VOID ? 9223372036854775807n : max;
  var tmp = new $discardCOROUTINE$(_this__u8e3s4, max, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function readAvailable(_this__u8e3s4, buffer, offset, length, $completion) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  var tmp = new $readAvailableCOROUTINE$(_this__u8e3s4, buffer, offset, length, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function toByteArray(_this__u8e3s4, $completion) {
  var tmp = new $toByteArrayCOROUTINE$(_this__u8e3s4, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function copyTo(_this__u8e3s4, channel, limit, $completion) {
  var tmp = new $copyToCOROUTINE$(_this__u8e3s4, channel, limit, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function skipIfFound(_this__u8e3s4, byteString, $completion) {
  var tmp = new $skipIfFoundCOROUTINE$(_this__u8e3s4, byteString, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function readPacket(_this__u8e3s4, packet, $completion) {
  var tmp = new $readPacketCOROUTINE$(_this__u8e3s4, packet, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function readUntil(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, $completion) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  ignoreMissing = ignoreMissing === VOID ? false : ignoreMissing;
  return (new ByteChannelScanner(_this__u8e3s4, matchString, writeChannel, limit)).l2n(ignoreMissing, $completion);
}
function readUTF8LineTo(_this__u8e3s4, out, max, lineEnding, $completion) {
  max = max === VOID ? 2147483647 : max;
  lineEnding = lineEnding === VOID ? Companion_getInstance_1().q2q_1 : lineEnding;
  var tmp = new $readUTF8LineToCOROUTINE$(_this__u8e3s4, out, max, lineEnding, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function rethrowCloseCauseIfNeeded(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.p2l();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function rethrowCloseCauseIfNeeded_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.p2l();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function get_availableForRead(_this__u8e3s4) {
  return convertToInt(_this__u8e3s4.k2l().u1t().o());
}
function readBuffer(_this__u8e3s4, $completion) {
  var tmp = new $readBufferCOROUTINE$(_this__u8e3s4, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function peek(_this__u8e3s4, count, $completion) {
  var tmp = new $peekCOROUTINE$(_this__u8e3s4, count, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function rethrowCloseCauseIfNeeded_1(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.p2l();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function readUTF8LineTo$checkLineEndingAllowed($lineEnding, lineEndingToCheck) {
  if (!LineEndingMode__contains_impl_q5pr68($lineEnding, lineEndingToCheck)) {
    throw IOException_init_$Create$('Unexpected line ending ' + LineEndingMode__toString_impl_j4h76r(lineEndingToCheck) + ', while expected ' + LineEndingMode__toString_impl_j4h76r($lineEnding));
  }
}
function $readRemainingCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.x2n_1 = _this__u8e3s4;
}
protoOf($readRemainingCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.y2n_1 = BytePacketBuilder();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!!this.x2n_1.r2l()) {
            this.d8_1 = 3;
            continue $sm;
          }

          this.y2n_1.m1v(this.x2n_1.k2l());
          this.d8_1 = 2;
          suspendResult = this.x2n_1.t2l(VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          rethrowCloseCauseIfNeeded_0(this.x2n_1);
          return this.y2n_1.u1t();
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $discardCOROUTINE$(_this__u8e3s4, max, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h2o_1 = _this__u8e3s4;
  this.i2o_1 = max;
}
protoOf($discardCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 5;
          this.j2o_1 = this.i2o_1;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!(this.j2o_1 > 0n && !this.h2o_1.r2l())) {
            this.d8_1 = 4;
            continue $sm;
          }

          if (get_availableForRead(this.h2o_1) === 0) {
            this.d8_1 = 2;
            suspendResult = this.h2o_1.t2l(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 3;
            continue $sm;
          }

        case 2:
          this.d8_1 = 3;
          continue $sm;
        case 3:
          var tmp0 = this.j2o_1;
          var b = get_remaining(this.h2o_1.k2l());
          var count = tmp0 <= b ? tmp0 : b;
          discard_0(this.h2o_1.k2l(), count);
          this.j2o_1 = subtract(this.j2o_1, count);
          this.d8_1 = 1;
          continue $sm;
        case 4:
          return subtract(this.i2o_1, this.j2o_1);
        case 5:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 5) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $readAvailableCOROUTINE$(_this__u8e3s4, buffer, offset, length, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s2o_1 = _this__u8e3s4;
  this.t2o_1 = buffer;
  this.u2o_1 = offset;
  this.v2o_1 = length;
}
protoOf($readAvailableCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          if (this.s2o_1.r2l())
            return -1;
          if (this.s2o_1.k2l().v1t()) {
            this.d8_1 = 1;
            suspendResult = this.s2o_1.t2l(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 2;
            continue $sm;
          }

        case 1:
          this.d8_1 = 2;
          continue $sm;
        case 2:
          if (this.s2o_1.r2l())
            return -1;
          return readAvailable_0(this.s2o_1.k2l(), this.t2o_1, this.u2o_1, this.v2o_1);
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $toByteArrayCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.e2p_1 = _this__u8e3s4;
}
protoOf($toByteArrayCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = readBuffer(this.e2p_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          return readBytes(ARGUMENT);
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $copyToCOROUTINE$(_this__u8e3s4, channel, limit, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n2p_1 = _this__u8e3s4;
  this.o2p_1 = channel;
  this.p2p_1 = limit;
}
protoOf($copyToCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 12;
          this.q2p_1 = this.p2p_1;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.e8_1 = 8;
          this.e8_1 = 7;
          this.d8_1 = 2;
          continue $sm;
        case 2:
          if (!(!this.n2p_1.r2l() && this.q2p_1 > 0n)) {
            this.d8_1 = 6;
            continue $sm;
          }

          if (this.n2p_1.k2l().v1t()) {
            this.d8_1 = 3;
            suspendResult = this.n2p_1.t2l(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 4;
            continue $sm;
          }

        case 3:
          this.d8_1 = 4;
          continue $sm;
        case 4:
          var tmp0 = this.q2p_1;
          var b = get_remaining(this.n2p_1.k2l());
          var count = tmp0 <= b ? tmp0 : b;
          this.n2p_1.k2l().x1u(this.o2p_1.n2l(), count);
          this.q2p_1 = subtract(this.q2p_1, count);
          this.d8_1 = 5;
          suspendResult = this.o2p_1.i2l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.d8_1 = 2;
          continue $sm;
        case 6:
          this.e8_1 = 12;
          this.d8_1 = 10;
          continue $sm;
        case 7:
          this.e8_1 = 8;
          var tmp_0 = this.g8_1;
          if (tmp_0 instanceof Error) {
            var cause = this.g8_1;
            this.n2p_1.v2l(cause);
            close_0(this.o2p_1, cause);
            throw cause;
          } else {
            throw this.g8_1;
          }

        case 8:
          this.e8_1 = 12;
          this.r2p_1 = this.g8_1;
          this.d8_1 = 9;
          suspendResult = this.o2p_1.i2l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 9:
          throw this.r2p_1;
        case 10:
          this.e8_1 = 12;
          this.d8_1 = 11;
          suspendResult = this.o2p_1.i2l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 11:
          return subtract(this.p2p_1, this.q2p_1);
        case 12:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 12) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $skipIfFoundCOROUTINE$(_this__u8e3s4, byteString, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.a2q_1 = _this__u8e3s4;
  this.b2q_1 = byteString;
}
protoOf($skipIfFoundCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.d8_1 = 1;
          suspendResult = peek(this.a2q_1, this.b2q_1.o(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          if (equals(ARGUMENT, this.b2q_1)) {
            this.d8_1 = 3;
            suspendResult = discard(this.a2q_1, fromInt(this.b2q_1.o()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 2;
            continue $sm;
          }

        case 2:
          return false;
        case 3:
          return true;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $readPacketCOROUTINE$(_this__u8e3s4, packet, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.k2q_1 = _this__u8e3s4;
  this.l2q_1 = packet;
}
protoOf($readPacketCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 6;
          this.m2q_1 = new Buffer();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!(this.m2q_1.o() < fromInt(this.l2q_1))) {
            this.d8_1 = 5;
            continue $sm;
          }

          if (this.k2q_1.k2l().v1t()) {
            this.d8_1 = 2;
            suspendResult = this.k2q_1.t2l(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 3;
            continue $sm;
          }

        case 2:
          this.d8_1 = 3;
          continue $sm;
        case 3:
          if (this.k2q_1.r2l()) {
            this.d8_1 = 5;
            continue $sm;
          } else {
            this.d8_1 = 4;
            continue $sm;
          }

        case 4:
          if (get_remaining(this.k2q_1.k2l()) > subtract(numberToLong(this.l2q_1), this.m2q_1.o())) {
            this.k2q_1.k2l().x1u(this.m2q_1, subtract(numberToLong(this.l2q_1), this.m2q_1.o()));
          } else {
            this.k2q_1.k2l().y1u(this.m2q_1);
          }

          this.d8_1 = 1;
          continue $sm;
        case 5:
          if (this.m2q_1.o() < fromInt(this.l2q_1)) {
            throw EOFException_init_$Create$('Not enough data available, required ' + this.l2q_1 + ' bytes but only ' + this.m2q_1.o().toString() + ' available');
          }

          return this.m2q_1;
        case 6:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 6) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $readUTF8LineToCOROUTINE$(_this__u8e3s4, out, max, lineEnding, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.a2r_1 = _this__u8e3s4;
  this.b2r_1 = out;
  this.c2r_1 = max;
  this.d2r_1 = lineEnding;
}
protoOf($readUTF8LineToCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 21;
          if (this.a2r_1.k2l().v1t()) {
            this.d8_1 = 1;
            suspendResult = this.a2r_1.t2l(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 2;
            continue $sm;
          }

        case 1:
          this.d8_1 = 2;
          continue $sm;
        case 2:
          if (this.a2r_1.r2l())
            return false;
          var tmp_0 = this;
          tmp_0.j2r_1 = new Buffer();
          this.d8_1 = 3;
          continue $sm;
        case 3:
          this.g2r_1 = this.j2r_1;
          this.f2r_1 = null;
          this.d8_1 = 4;
          continue $sm;
        case 4:
          this.d8_1 = 5;
          continue $sm;
        case 5:
          this.d8_1 = 6;
          continue $sm;
        case 6:
          this.e8_1 = 18;
          this.e8_1 = 17;
          this.i2r_1 = this.g2r_1;
          this.d8_1 = 7;
          continue $sm;
        case 7:
          if (!!this.a2r_1.r2l()) {
            this.d8_1 = 14;
            continue $sm;
          }

          this.d8_1 = 8;
          continue $sm;
        case 8:
          if (!!this.a2r_1.k2l().v1t()) {
            this.d8_1 = 12;
            continue $sm;
          }

          var b = this.a2r_1.k2l().y1t();
          if (b === 13) {
            if (this.a2r_1.k2l().v1t()) {
              this.d8_1 = 10;
              suspendResult = this.a2r_1.t2l(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.d8_1 = 11;
              continue $sm;
            }
          } else {
            if (b === 10) {
              readUTF8LineTo$checkLineEndingAllowed(this.d2r_1, Companion_getInstance_1().o2q_1);
              this.b2r_1.k(readString(this.i2r_1));
              this.h2r_1 = true;
              this.e8_1 = 21;
              this.d8_1 = 15;
              continue $sm;
            } else {
              this.i2r_1.n1v(b);
              this.d8_1 = 9;
              continue $sm;
            }
          }

        case 9:
          this.d8_1 = 8;
          continue $sm;
        case 10:
          this.d8_1 = 11;
          continue $sm;
        case 11:
          if (this.a2r_1.k2l().u1t().q1u(0n) === 10) {
            readUTF8LineTo$checkLineEndingAllowed(this.d2r_1, Companion_getInstance_1().p2q_1);
            discard_0(this.a2r_1.k2l(), 1n);
          } else {
            readUTF8LineTo$checkLineEndingAllowed(this.d2r_1, Companion_getInstance_1().n2q_1);
          }

          this.b2r_1.k(readString(this.i2r_1));
          this.h2r_1 = true;
          this.e8_1 = 21;
          this.d8_1 = 15;
          continue $sm;
        case 12:
          if (this.i2r_1.o() >= fromInt(this.c2r_1)) {
            throw new TooLongLineException('Line exceeds limit of ' + this.c2r_1 + ' characters');
          }

          this.d8_1 = 13;
          suspendResult = this.a2r_1.t2l(VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 13:
          this.d8_1 = 7;
          continue $sm;
        case 14:
          var tmp_1 = this;
          var this_0 = this.i2r_1.o() > 0n;
          if (this_0) {
            this.b2r_1.k(readString(this.i2r_1));
          }

          tmp_1.h2r_1 = this_0;
          this.e8_1 = 21;
          this.d8_1 = 15;
          var tmp_2 = this;
          continue $sm;
        case 15:
          var tmp_3 = this.h2r_1;
          this.e8_1 = 21;
          closeFinally(this.g2r_1, this.f2r_1);
          return tmp_3;
        case 16:
          this.e8_1 = 21;
          var tmp_4 = this;
          closeFinally(this.g2r_1, this.f2r_1);
          tmp_4.e2r_1 = Unit_instance;
          this.d8_1 = 20;
          continue $sm;
        case 17:
          this.e8_1 = 18;
          var tmp_5 = this.g8_1;
          if (tmp_5 instanceof Error) {
            var e = this.g8_1;
            var tmp_6 = this;
            this.f2r_1 = e;
            throw e;
          } else {
            throw this.g8_1;
          }

        case 18:
          this.e8_1 = 21;
          var t = this.g8_1;
          closeFinally(this.g2r_1, this.f2r_1);
          throw t;
        case 19:
          this.e8_1 = 21;
          closeFinally(this.g2r_1, this.f2r_1);
          if (false) {
            this.d8_1 = 3;
            continue $sm;
          }

          this.d8_1 = 20;
          continue $sm;
        case 20:
          return Unit_instance;
        case 21:
          throw this.g8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.e8_1 === 21) {
        throw e_0;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e_0;
      }
    }
   while (true);
};
function $readBufferCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s2r_1 = _this__u8e3s4;
}
protoOf($readBufferCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.t2r_1 = new Buffer();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!!this.s2r_1.r2l()) {
            this.d8_1 = 3;
            continue $sm;
          }

          this.t2r_1.m1v(this.s2r_1.k2l());
          this.d8_1 = 2;
          suspendResult = this.s2r_1.t2l(VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          var tmp0_safe_receiver = this.s2r_1.p2l();
          if (tmp0_safe_receiver == null)
            null;
          else {
            throw tmp0_safe_receiver;
          }

          return this.t2r_1;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $peekCOROUTINE$(_this__u8e3s4, count, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.c2s_1 = _this__u8e3s4;
  this.d2s_1 = count;
}
protoOf($peekCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          if (this.c2s_1.r2l())
            return null;
          this.d8_1 = 1;
          suspendResult = this.c2s_1.s2l(this.d2s_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          if (!suspendResult) {
            return null;
          } else {
            this.d8_1 = 2;
            continue $sm;
          }

        case 2:
          return readByteString(this.c2s_1.k2l().z1u(), this.d2s_1);
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function ByteWriteChannel() {
}
function flushIfNeeded(_this__u8e3s4, $completion) {
  var tmp = new $flushIfNeededCOROUTINE$(_this__u8e3s4, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function $flushIfNeededCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.m2s_1 = _this__u8e3s4;
}
protoOf($flushIfNeededCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          rethrowCloseCauseIfNeeded_1(this.m2s_1);
          if (this.m2s_1.j2l() || get_size(this.m2s_1.n2l()) >= 1048576) {
            this.d8_1 = 1;
            suspendResult = this.m2s_1.i2l(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.d8_1 = 2;
            continue $sm;
          }

        case 1:
          this.d8_1 = 2;
          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function get_NO_CALLBACK() {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return NO_CALLBACK;
}
var NO_CALLBACK;
function WriterJob(channel, job) {
  this.n2s_1 = channel;
  this.o2s_1 = job;
}
protoOf(WriterJob).f23 = function () {
  return this.o2s_1;
};
function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
  autoFlush = autoFlush === VOID ? false : autoFlush;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return writer_0(_this__u8e3s4, coroutineContext, new ByteChannel(), block);
}
function WriterScope(channel, coroutineContext) {
  this.p2s_1 = channel;
  this.q2s_1 = coroutineContext;
}
protoOf(WriterScope).f1x = function () {
  return this.q2s_1;
};
function writeFully(_this__u8e3s4, value, startIndex, endIndex, $completion) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? value.length : endIndex;
  _this__u8e3s4.n2l().e1v(value, startIndex, endIndex);
  return flushIfNeeded(_this__u8e3s4, $completion);
}
function close_0(_this__u8e3s4, cause) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  if (cause == null) {
    fireAndForget(ByteWriteChannel$flushAndClose$ref_0(_this__u8e3s4));
  } else {
    _this__u8e3s4.v2l(cause);
  }
}
function invokeOnCompletion(_this__u8e3s4, block) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return _this__u8e3s4.f23().h1y(block);
}
function writer_0(_this__u8e3s4, coroutineContext, channel, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  // Inline function 'kotlin.apply' call
  var this_0 = launch(_this__u8e3s4, coroutineContext, VOID, writer$slambda_0(block, channel, null));
  this_0.h1y(writer$lambda(channel));
  var job = this_0;
  return new WriterJob(channel, job);
}
function fireAndForget(_this__u8e3s4) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  startCoroutineCancellable(_this__u8e3s4, get_NO_CALLBACK());
}
function writeByte(_this__u8e3s4, value, $completion) {
  _this__u8e3s4.n2l().n1v(value);
  return flushIfNeeded(_this__u8e3s4, $completion);
}
function NO_CALLBACK$1() {
  this.r2s_1 = EmptyCoroutineContext_instance;
}
protoOf(NO_CALLBACK$1).j8 = function () {
  return this.r2s_1;
};
protoOf(NO_CALLBACK$1).k8 = function (result) {
  return Unit_instance;
};
protoOf(NO_CALLBACK$1).o8 = function (result) {
  return this.k8(result);
};
function ByteWriteChannel$flushAndClose$ref(p0) {
  this.s2s_1 = p0;
}
protoOf(ByteWriteChannel$flushAndClose$ref).t2s = function ($completion) {
  return this.s2s_1.u2l($completion);
};
protoOf(ByteWriteChannel$flushAndClose$ref).u9 = function ($completion) {
  return this.t2s($completion);
};
function ByteWriteChannel$flushAndClose$ref_0(p0) {
  var i = new ByteWriteChannel$flushAndClose$ref(p0);
  var l = function ($completion) {
    return i.t2s($completion);
  };
  l.callableName = 'flushAndClose';
  l.$arity = 0;
  return l;
}
function writer$slambda($block, $channel, resultContinuation) {
  this.c2t_1 = $block;
  this.d2t_1 = $channel;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(writer$slambda).l2t = function ($this$launch, $completion) {
  var tmp = this.m2t($this$launch, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(writer$slambda).x8 = function (p1, $completion) {
  return this.l2t((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(writer$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 14;
          this.h2t_1 = Job(get_job(this.e2t_1.f1x()));
          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.e8_1 = 4;
          this.e8_1 = 3;
          this.d8_1 = 2;
          suspendResult = this.c2t_1(new WriterScope(this.d2t_1, this.e2t_1.f1x().fh(this.h2t_1)), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.h2t_1.b24();
          var tmp_0;
          if (get_job(this.e2t_1.f1x()).b1y()) {
            this.d2t_1.v2l(get_job(this.e2t_1.f1x()).e1y());
            tmp_0 = Unit_instance;
          }

          this.e8_1 = 14;
          this.d8_1 = 9;
          continue $sm;
        case 3:
          this.e8_1 = 4;
          var tmp_1 = this.g8_1;
          if (tmp_1 instanceof Error) {
            var cause = this.g8_1;
            cancel(this.h2t_1, 'Exception thrown while writing to channel', cause);
            this.d2t_1.v2l(cause);
            this.e8_1 = 14;
            this.d8_1 = 9;
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 4:
          this.e8_1 = 14;
          this.i2t_1 = this.g8_1;
          this.d8_1 = 5;
          suspendResult = this.h2t_1.l1y(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.e2t_1;
          this.e8_1 = 7;
          var tmp_2 = this;
          tmp_2.k2t_1 = Companion_instance;
          this.d8_1 = 6;
          suspendResult = this.d2t_1.u2l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 6:
          var tmp_3 = this;
          this.k2t_1;
          tmp_3.j2t_1 = _Result___init__impl__xyqfz8(Unit_instance);
          this.e8_1 = 14;
          this.d8_1 = 8;
          continue $sm;
        case 7:
          this.e8_1 = 14;
          var tmp_4 = this.g8_1;
          if (tmp_4 instanceof Error) {
            var e = this.g8_1;
            var tmp_5 = this;
            tmp_5.j2t_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.d8_1 = 8;
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 8:
          this.e8_1 = 14;
          throw this.i2t_1;
        case 9:
          this.e8_1 = 14;
          this.d8_1 = 10;
          suspendResult = this.h2t_1.l1y(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 10:
          this.e2t_1;
          this.e8_1 = 12;
          var tmp_6 = this;
          tmp_6.g2t_1 = Companion_instance;
          this.d8_1 = 11;
          suspendResult = this.d2t_1.u2l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 11:
          var tmp_7 = this;
          this.g2t_1;
          tmp_7.f2t_1 = _Result___init__impl__xyqfz8(Unit_instance);
          this.e8_1 = 14;
          this.d8_1 = 13;
          continue $sm;
        case 12:
          this.e8_1 = 14;
          var tmp_8 = this.g8_1;
          if (tmp_8 instanceof Error) {
            var e_0 = this.g8_1;
            var tmp_9 = this;
            tmp_9.f2t_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
            this.d8_1 = 13;
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 13:
          this.e8_1 = 14;
          return Unit_instance;
        case 14:
          throw this.g8_1;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.e8_1 === 14) {
        throw e_1;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e_1;
      }
    }
   while (true);
};
protoOf(writer$slambda).m2t = function ($this$launch, completion) {
  var i = new writer$slambda(this.c2t_1, this.d2t_1, completion);
  i.e2t_1 = $this$launch;
  return i;
};
function writer$slambda_0($block, $channel, resultContinuation) {
  var i = new writer$slambda($block, $channel, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.l2t($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function writer$lambda($channel) {
  return function (it) {
    var tmp;
    if (!(it == null) && !$channel.o2l()) {
      $channel.v2l(it);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
var properties_initialized_ByteWriteChannelOperations_kt_acrf6u;
function _init_properties_ByteWriteChannelOperations_kt__i7slrs() {
  if (!properties_initialized_ByteWriteChannelOperations_kt_acrf6u) {
    properties_initialized_ByteWriteChannelOperations_kt_acrf6u = true;
    NO_CALLBACK = new NO_CALLBACK$1();
  }
}
function get_CLOSED() {
  _init_properties_CloseToken_kt__9ucr41();
  return CLOSED;
}
var CLOSED;
function ClosedByteChannelException$_init_$ref_yjp351() {
  var l = function (p0) {
    return new ClosedByteChannelException(p0);
  };
  l.callableName = '<init>';
  return l;
}
function CloseToken(origin) {
  this.l2l_1 = origin;
}
protoOf(CloseToken).n2t = function (wrap) {
  var tmp0_subject = this.l2l_1;
  var tmp;
  if (tmp0_subject == null) {
    tmp = null;
  } else {
    if (isInterface(tmp0_subject, CopyableThrowable)) {
      tmp = this.l2l_1.p24();
    } else {
      if (tmp0_subject instanceof CancellationException) {
        tmp = CancellationException_init_$Create$(this.l2l_1.message, this.l2l_1);
      } else {
        tmp = wrap(this.l2l_1);
      }
    }
  }
  return tmp;
};
protoOf(CloseToken).q2l = function (wrap, $super) {
  var tmp;
  if (wrap === VOID) {
    tmp = ClosedByteChannelException$_init_$ref_yjp351();
  } else {
    tmp = wrap;
  }
  wrap = tmp;
  return $super === VOID ? this.n2t(wrap) : $super.n2t.call(this, wrap);
};
protoOf(CloseToken).m2l = function (wrap) {
  var tmp0_safe_receiver = this.n2t(wrap);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return tmp;
};
var properties_initialized_CloseToken_kt_lgg8zn;
function _init_properties_CloseToken_kt__9ucr41() {
  if (!properties_initialized_CloseToken_kt_lgg8zn) {
    properties_initialized_CloseToken_kt_lgg8zn = true;
    CLOSED = new CloseToken(null);
  }
}
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.p2t_1.m1v($this.o2t_1.k2l());
  $this.q2t_1 = add($this.q2t_1, appended);
}
function updateConsumed($this) {
  $this.r2t_1 = add($this.r2t_1, subtract($this.q2t_1, $this.p2t_1.o()));
  $this.q2t_1 = $this.p2t_1.o();
}
function $awaitContentCOROUTINE$_0(_this__u8e3s4, min, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.a2u_1 = _this__u8e3s4;
  this.b2u_1 = min;
}
protoOf($awaitContentCOROUTINE$_0).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          if (this.a2u_1.k2l().o() >= fromInt(this.b2u_1)) {
            return true;
          }

          this.d8_1 = 1;
          suspendResult = this.a2u_1.o2t_1.s2l(this.b2u_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          if (suspendResult) {
            transferFromDelegate(this.a2u_1);
            return true;
          } else {
            this.d8_1 = 2;
            continue $sm;
          }

        case 2:
          return false;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function CountedByteReadChannel(delegate) {
  this.o2t_1 = delegate;
  this.p2t_1 = new Buffer();
  this.q2t_1 = 0n;
  this.r2t_1 = 0n;
}
protoOf(CountedByteReadChannel).c2u = function () {
  updateConsumed(this);
  return this.r2t_1;
};
protoOf(CountedByteReadChannel).p2l = function () {
  return this.o2t_1.p2l();
};
protoOf(CountedByteReadChannel).r2l = function () {
  return this.p2t_1.v1t() && this.o2t_1.r2l();
};
protoOf(CountedByteReadChannel).k2l = function () {
  transferFromDelegate(this);
  return this.p2t_1;
};
protoOf(CountedByteReadChannel).s2l = function (min, $completion) {
  var tmp = new $awaitContentCOROUTINE$_0(this, min, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(CountedByteReadChannel).v2l = function (cause) {
  this.o2t_1.v2l(cause);
  this.p2t_1.i3();
};
function counted(_this__u8e3s4) {
  return new CountedByteReadChannel(_this__u8e3s4);
}
function readText(_this__u8e3s4) {
  return readString_0(_this__u8e3s4);
}
function ClosedByteChannelException(cause) {
  cause = cause === VOID ? null : cause;
  IOException_init_$Init$(cause == null ? null : cause.message, cause, this);
  captureStack(this, ClosedByteChannelException);
}
function ClosedReadChannelException(cause) {
  cause = cause === VOID ? null : cause;
  ClosedByteChannelException.call(this, cause);
  captureStack(this, ClosedReadChannelException);
}
function ClosedWriteChannelException(cause) {
  cause = cause === VOID ? null : cause;
  ClosedByteChannelException.call(this, cause);
  captureStack(this, ClosedWriteChannelException);
}
function _LineEndingMode___init__impl__jo5bul(mode) {
  return mode;
}
function _get_mode__dah3bc($this) {
  return $this;
}
function LineEndingMode__contains_impl_q5pr68($this, other) {
  return (_get_mode__dah3bc($this) | _get_mode__dah3bc(other)) === _get_mode__dah3bc($this);
}
function LineEndingMode__plus_impl_ttpz2j($this, other) {
  return _LineEndingMode___init__impl__jo5bul(_get_mode__dah3bc($this) | _get_mode__dah3bc(other));
}
function LineEndingMode__toString_impl_j4h76r($this) {
  var tmp;
  if ($this === Companion_getInstance_1().n2q_1) {
    tmp = 'CR';
  } else if ($this === Companion_getInstance_1().o2q_1) {
    tmp = 'LF';
  } else if ($this === Companion_getInstance_1().p2q_1) {
    tmp = 'CRLF';
  } else {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = Companion_getInstance_1().r2q_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      var it = element.d2u_1;
      if (LineEndingMode__contains_impl_q5pr68($this, it)) {
        destination.j(element);
      }
    }
    tmp = toString_1(destination);
  }
  return tmp;
}
function Companion_1() {
  Companion_instance_2 = this;
  this.n2q_1 = _LineEndingMode___init__impl__jo5bul(1);
  this.o2q_1 = _LineEndingMode___init__impl__jo5bul(2);
  this.p2q_1 = _LineEndingMode___init__impl__jo5bul(4);
  this.q2q_1 = _LineEndingMode___init__impl__jo5bul(7);
  this.r2q_1 = listOf([new LineEndingMode(this.n2q_1), new LineEndingMode(this.o2q_1), new LineEndingMode(this.p2q_1)]);
}
var Companion_instance_2;
function Companion_getInstance_1() {
  if (Companion_instance_2 == null)
    new Companion_1();
  return Companion_instance_2;
}
function LineEndingMode__hashCode_impl_2mopm4($this) {
  return $this;
}
function LineEndingMode__equals_impl_qyr4nk($this, other) {
  if (!(other instanceof LineEndingMode))
    return false;
  if (!($this === other.d2u_1))
    return false;
  return true;
}
function LineEndingMode(mode) {
  Companion_getInstance_1();
  this.d2u_1 = mode;
}
protoOf(LineEndingMode).toString = function () {
  return LineEndingMode__toString_impl_j4h76r(this.d2u_1);
};
protoOf(LineEndingMode).hashCode = function () {
  return LineEndingMode__hashCode_impl_2mopm4(this.d2u_1);
};
protoOf(LineEndingMode).equals = function (other) {
  return LineEndingMode__equals_impl_qyr4nk(this.d2u_1, other);
};
function SourceByteReadChannel(source) {
  this.e2u_1 = source;
  this.f2u_1 = null;
}
protoOf(SourceByteReadChannel).p2l = function () {
  var tmp0_safe_receiver = this.f2u_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2l();
};
protoOf(SourceByteReadChannel).r2l = function () {
  return this.e2u_1.v1t();
};
protoOf(SourceByteReadChannel).k2l = function () {
  var tmp0_safe_receiver = this.p2l();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return this.e2u_1.u1t();
};
protoOf(SourceByteReadChannel).s2l = function (min, $completion) {
  var tmp0_safe_receiver = this.p2l();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return this.e2u_1.x1t(fromInt(min));
};
protoOf(SourceByteReadChannel).v2l = function (cause) {
  if (!(this.f2u_1 == null))
    return Unit_instance;
  this.e2u_1.i3();
  var tmp = this;
  var tmp1_elvis_lhs = cause == null ? null : cause.message;
  tmp.f2u_1 = new CloseToken(IOException_init_$Create$_0(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
};
function decode(_this__u8e3s4, input, max) {
  max = max === VOID ? 2147483647 : max;
  var tmp0 = fromInt(max);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = input.u1t().o();
  var tmp$ret$0 = tmp0 <= b ? tmp0 : b;
  // Inline function 'kotlin.text.buildString' call
  var capacity = convertToInt(tmp$ret$0);
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$(capacity);
  decode_0(_this__u8e3s4, input, this_0, max);
  return this_0.toString();
}
function encode(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  encodeToImpl(_this__u8e3s4, builder, input, fromIndex, toIndex);
  return builder;
}
function TooLongLineException(message) {
  MalformedInputException.call(this, message);
  captureStack(this, TooLongLineException);
}
function encodeToImpl(_this__u8e3s4, destination, input, fromIndex, toIndex) {
  var start = fromIndex;
  if (start >= toIndex)
    return Unit_instance;
  $l$loop: while (true) {
    var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, destination);
    // Inline function 'kotlin.check' call
    if (!(rc >= 0)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    start = start + rc | 0;
    if (start >= toIndex)
      break $l$loop;
  }
}
function canRead(_this__u8e3s4) {
  return !_this__u8e3s4.v1t();
}
function readBytes(_this__u8e3s4, count) {
  count = count === VOID ? convertToInt(_this__u8e3s4.o()) : count;
  return readByteArray(_this__u8e3s4, count);
}
function writeFully_0(_this__u8e3s4, buffer, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  _this__u8e3s4.e1v(buffer, offset, offset + length | 0);
}
function BytePacketBuilder() {
  return new Buffer();
}
function get_size(_this__u8e3s4) {
  return convertToInt(_this__u8e3s4.u1t().o());
}
var ByteReadPacketEmpty;
function get_remaining(_this__u8e3s4) {
  _init_properties_ByteReadPacket_kt__28475y();
  return _this__u8e3s4.u1t().o();
}
function takeWhile(_this__u8e3s4, block) {
  _init_properties_ByteReadPacket_kt__28475y();
  while (!_this__u8e3s4.v1t() && block(_this__u8e3s4.u1t())) {
  }
}
function discard_0(_this__u8e3s4, count) {
  count = count === VOID ? 9223372036854775807n : count;
  _init_properties_ByteReadPacket_kt__28475y();
  _this__u8e3s4.x1t(count);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = get_remaining(_this__u8e3s4);
  var countToDiscard = count <= b ? count : b;
  _this__u8e3s4.u1t().s1u(countToDiscard);
  return countToDiscard;
}
var properties_initialized_ByteReadPacket_kt_hw4st4;
function _init_properties_ByteReadPacket_kt__28475y() {
  if (!properties_initialized_ByteReadPacket_kt_hw4st4) {
    properties_initialized_ByteReadPacket_kt_hw4st4 = true;
    ByteReadPacketEmpty = new Buffer();
  }
}
function readAvailable_0(_this__u8e3s4, buffer, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  var result = _this__u8e3s4.t1u(buffer, offset, offset + length | 0);
  return result === -1 ? 0 : result;
}
function readText_0(_this__u8e3s4, charset, max) {
  charset = charset === VOID ? Charsets_getInstance().g2u_1 : charset;
  max = max === VOID ? 2147483647 : max;
  if (charset.equals(Charsets_getInstance().g2u_1)) {
    if (max === 2147483647)
      return readString_0(_this__u8e3s4);
    var tmp0 = _this__u8e3s4.u1t().o();
    // Inline function 'kotlin.math.min' call
    var b = fromInt(max);
    var count = tmp0 <= b ? tmp0 : b;
    return readString_1(_this__u8e3s4, count);
  }
  return decode(charset.j2u(), _this__u8e3s4, max);
}
function toByteArray_0(_this__u8e3s4, charset) {
  charset = charset === VOID ? Charsets_getInstance().g2u_1 : charset;
  if (charset.equals(Charsets_getInstance().g2u_1))
    return encodeToByteArray(_this__u8e3s4, VOID, VOID, true);
  return encodeToByteArray_0(charset.k2u(), _this__u8e3s4, 0, _this__u8e3s4.length);
}
function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
  charset = charset === VOID ? Charsets_getInstance().g2u_1 : charset;
  if (charset === Charsets_getInstance().g2u_1) {
    return writeString(_this__u8e3s4, toString_1(text), fromIndex, toIndex);
  }
  encodeToImpl(charset.k2u(), _this__u8e3s4, text, fromIndex, toIndex);
}
function get_ByteArrayPool() {
  _init_properties_ByteArrayPool_kt__kfi3uj();
  return ByteArrayPool;
}
var ByteArrayPool;
function ByteArrayPool$1() {
  DefaultPool.call(this, 128);
}
protoOf(ByteArrayPool$1).o2u = function () {
  return new Int8Array(4096);
};
var properties_initialized_ByteArrayPool_kt_td6pfh;
function _init_properties_ByteArrayPool_kt__kfi3uj() {
  if (!properties_initialized_ByteArrayPool_kt_td6pfh) {
    properties_initialized_ByteArrayPool_kt_td6pfh = true;
    ByteArrayPool = new ByteArrayPool$1();
  }
}
function ObjectPool() {
}
function NoPoolImpl() {
}
protoOf(NoPoolImpl).w2u = function (instance) {
  return Unit_instance;
};
protoOf(NoPoolImpl).t20 = function () {
  return Unit_instance;
};
function Companion_2() {
}
protoOf(Companion_2).x2u = function (name) {
  switch (name) {
    case 'UTF-8':
    case 'utf-8':
    case 'UTF8':
    case 'utf8':
      return Charsets_getInstance().g2u_1;
  }
  var tmp;
  var tmp_0;
  switch (name) {
    case 'ISO-8859-1':
    case 'iso-8859-1':
      tmp_0 = true;
      break;
    default:
      // Inline function 'kotlin.let' call

      var it = replace_0(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
      var tmp_1;
      if (it === 'iso-8859-1') {
        tmp_1 = true;
      } else {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_1 = it.toLowerCase() === 'iso-8859-1';
      }

      tmp_0 = tmp_1;
      break;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = name === 'latin1' || name === 'Latin1';
  }
  if (tmp) {
    return Charsets_getInstance().h2u_1;
  }
  throw IllegalArgumentException_init_$Create$('Charset ' + name + ' is not supported');
};
protoOf(Companion_2).y2u = function (charset) {
  var tmp;
  switch (charset) {
    case 'UTF-8':
    case 'utf-8':
    case 'UTF8':
    case 'utf8':
      tmp = true;
      break;
    default:
      var tmp_0;
      var tmp_1;
      switch (charset) {
        case 'ISO-8859-1':
        case 'iso-8859-1':
          tmp_1 = true;
          break;
        default:
          // Inline function 'kotlin.let' call

          var it = replace_0(charset, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
          var tmp_2;
          if (it === 'iso-8859-1') {
            tmp_2 = true;
          } else {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_2 = it.toLowerCase() === 'iso-8859-1';
          }

          tmp_1 = tmp_2;
          break;
      }

      if (tmp_1) {
        tmp_0 = true;
      } else {
        tmp_0 = charset === 'latin1';
      }

      if (tmp_0) {
        tmp = true;
      } else {
        tmp = false;
      }

      break;
  }
  return tmp;
};
var Companion_instance_3;
function Companion_getInstance_2() {
  return Companion_instance_3;
}
function Charset(_name) {
  this.i2u_1 = _name;
}
protoOf(Charset).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !(this.constructor == other.constructor))
    return false;
  if (!(other instanceof Charset))
    THROW_CCE();
  return this.i2u_1 === other.i2u_1;
};
protoOf(Charset).hashCode = function () {
  return getStringHashCode(this.i2u_1);
};
protoOf(Charset).toString = function () {
  return this.i2u_1;
};
function Charsets() {
  Charsets_instance = this;
  this.g2u_1 = new CharsetImpl('UTF-8');
  this.h2u_1 = new CharsetImpl('ISO-8859-1');
}
var Charsets_instance;
function Charsets_getInstance() {
  if (Charsets_instance == null)
    new Charsets();
  return Charsets_instance;
}
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.i2u_1;
}
function MalformedInputException(message) {
  IOException_init_$Init$_0(message, this);
  captureStack(this, MalformedInputException);
}
function CharsetDecoder(_charset) {
  this.z2u_1 = _charset;
}
function isSupported(_this__u8e3s4, name) {
  return Companion_instance_3.y2u(name);
}
function forName(_this__u8e3s4, name) {
  return Companion_instance_3.x2u(name);
}
function CharsetEncoder(_charset) {
  this.a2v_1 = _charset;
}
function decode_0(_this__u8e3s4, input, dst, max) {
  var decoder = Decoder(get_name(get_charset(_this__u8e3s4)), true);
  var tmp0 = input.u1t().o();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = fromInt(max);
  var count = tmp0 <= b ? tmp0 : b;
  var tmp = readByteArray(input, convertToInt(count));
  var array = tmp instanceof Int8Array ? tmp : THROW_CCE();
  var tmp_0;
  try {
    tmp_0 = decoder.b2v(array);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var cause = $p;
      var tmp0_elvis_lhs = cause.message;
      throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
    } else {
      throw $p;
    }
  }
  var result = tmp_0;
  dst.k(result);
  return result.length;
}
function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(fromIndex <= toIndex)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException_init_$Create$(toString_1(message));
  }
  if (get_charset_0(_this__u8e3s4).equals(Charsets_getInstance().h2u_1)) {
    return encodeISO88591(input, fromIndex, toIndex, dst);
  }
  // Inline function 'kotlin.require' call
  if (!(get_charset_0(_this__u8e3s4) === Charsets_getInstance().g2u_1)) {
    var message_0 = 'Only UTF-8 encoding is supported in JS';
    throw IllegalArgumentException_init_$Create$(toString_1(message_0));
  }
  var encoder = new TextEncoder();
  // Inline function 'kotlin.text.substring' call
  var tmp$ret$5 = toString_1(charSequenceSubSequence(input, fromIndex, toIndex));
  var result = encoder.encode(tmp$ret$5);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  dst.h1v(result);
  return result.length;
}
function encodeToByteArray_0(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  return encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex);
}
function CharsetImpl(name) {
  Charset.call(this, name);
}
protoOf(CharsetImpl).k2u = function () {
  return new CharsetEncoderImpl(this);
};
protoOf(CharsetImpl).j2u = function () {
  return new CharsetDecoderImpl(this);
};
function get_charset(_this__u8e3s4) {
  return _this__u8e3s4.z2u_1;
}
function get_charset_0(_this__u8e3s4) {
  return _this__u8e3s4.a2v_1;
}
function encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  var start = fromIndex;
  if (start >= toIndex)
    return new Int8Array(0);
  var dst = new Buffer();
  var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, dst);
  start = start + rc | 0;
  if (start === toIndex) {
    return readByteArray_0(dst);
  }
  encodeToImpl(_this__u8e3s4, dst, input, start, toIndex);
  return readByteArray_0(dst);
}
function CharsetEncoderImpl(charset) {
  CharsetEncoder.call(this, charset);
  this.e2v_1 = charset;
}
protoOf(CharsetEncoderImpl).toString = function () {
  return 'CharsetEncoderImpl(charset=' + this.e2v_1.toString() + ')';
};
protoOf(CharsetEncoderImpl).hashCode = function () {
  return this.e2v_1.hashCode();
};
protoOf(CharsetEncoderImpl).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CharsetEncoderImpl))
    return false;
  if (!this.e2v_1.equals(other.e2v_1))
    return false;
  return true;
};
function CharsetDecoderImpl(charset) {
  CharsetDecoder.call(this, charset);
  this.g2v_1 = charset;
}
protoOf(CharsetDecoderImpl).toString = function () {
  return 'CharsetDecoderImpl(charset=' + this.g2v_1.toString() + ')';
};
protoOf(CharsetDecoderImpl).hashCode = function () {
  return this.g2v_1.hashCode();
};
protoOf(CharsetDecoderImpl).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CharsetDecoderImpl))
    return false;
  if (!this.g2v_1.equals(other.g2v_1))
    return false;
  return true;
};
function Decoder(encoding, fatal) {
  fatal = fatal === VOID ? true : fatal;
  var tmp;
  try {
    tmp = toKtor(new TextDecoder(encoding, textDecoderOptions(fatal)));
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var cause = $p;
      tmp_0 = new TextDecoderFallback(encoding, fatal);
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function toKtor(_this__u8e3s4) {
  return new toKtor$1(_this__u8e3s4);
}
function textDecoderOptions(fatal) {
  fatal = fatal === VOID ? false : fatal;
  // Inline function 'kotlin.apply' call
  var this_0 = new Object();
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.with' call
  this_0.fatal = fatal;
  return this_0;
}
function toKtor$1($this_toKtor) {
  this.h2v_1 = $this_toKtor;
}
protoOf(toKtor$1).b2v = function (buffer) {
  return this.h2v_1.decode(buffer);
};
function get_ENCODING_ALIASES() {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return ENCODING_ALIASES;
}
var ENCODING_ALIASES;
function get_REPLACEMENT() {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return REPLACEMENT;
}
var REPLACEMENT;
function TextDecoderFallback(encoding, fatal) {
  this.i2v_1 = fatal;
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var requestedEncoding = toString_1(trim(isCharSequence(encoding) ? encoding : THROW_CCE())).toLowerCase();
  // Inline function 'kotlin.check' call
  if (!get_ENCODING_ALIASES().q1(requestedEncoding)) {
    var message = encoding + ' is not supported.';
    throw IllegalStateException_init_$Create$(toString_1(message));
  }
}
protoOf(TextDecoderFallback).b2v = function (buffer) {
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  var bytes = buffer instanceof Int8Array ? buffer : THROW_CCE();
  var inductionVariable = 0;
  var last = bytes.length;
  if (inductionVariable < last)
    $l$loop: do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'org.khronos.webgl.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var byte = bytes[index];
      var point = toCodePoint(byte);
      if (point < 0) {
        // Inline function 'kotlin.check' call
        if (!!this.i2v_1) {
          var message = 'Invalid character: ' + point;
          throw IllegalStateException_init_$Create$(toString_1(message));
        }
        writeFully_0(builder, get_REPLACEMENT());
        continue $l$loop;
      }
      if (point > 255) {
        builder.n1v(toByte(point >> 8));
      }
      builder.n1v(toByte(point & 255));
    }
     while (inductionVariable < last);
  return decodeToString(readByteArray_0(builder));
};
function toCodePoint(_this__u8e3s4) {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  var value = _this__u8e3s4 & 255;
  if (isASCII(value)) {
    return value;
  }
  return get_WIN1252_TABLE()[value - 128 | 0];
}
function isASCII(_this__u8e3s4) {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return 0 <= _this__u8e3s4 ? _this__u8e3s4 <= 127 : false;
}
var properties_initialized_TextDecoderFallback_js_kt_6rekzk;
function _init_properties_TextDecoderFallback_js_kt__an7r6m() {
  if (!properties_initialized_TextDecoderFallback_js_kt_6rekzk) {
    properties_initialized_TextDecoderFallback_js_kt_6rekzk = true;
    ENCODING_ALIASES = setOf(['ansi_x3.4-1968', 'ascii', 'cp1252', 'cp819', 'csisolatin1', 'ibm819', 'iso-8859-1', 'iso-ir-100', 'iso8859-1', 'iso88591', 'iso_8859-1', 'iso_8859-1:1987', 'l1', 'latin1', 'us-ascii', 'windows-1252', 'x-cp1252']);
    // Inline function 'kotlin.byteArrayOf' call
    REPLACEMENT = new Int8Array([-17, -65, -67]);
  }
}
function get_DEVELOPMENT_MODE() {
  return false;
}
function ioDispatcher() {
  return Dispatchers_getInstance().k24_1;
}
function encodeISO88591(input, fromIndex, toIndex, dst) {
  if (fromIndex >= toIndex)
    return 0;
  var inductionVariable = fromIndex;
  if (inductionVariable < toIndex)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(input, index);
      var character = Char__toInt_impl_vasixd(this_0);
      if (character > 255) {
        failedToMapError(character);
      }
      dst.n1v(toByte(character));
    }
     while (inductionVariable < toIndex);
  return toIndex - fromIndex | 0;
}
function failedToMapError(ch) {
  throw new MalformedInputException('The character with unicode point ' + ch + " couldn't be mapped to ISO-8859-1 character");
}
function get_WIN1252_TABLE() {
  _init_properties_Win1252Table_kt__tl0v64();
  return WIN1252_TABLE;
}
var WIN1252_TABLE;
var properties_initialized_Win1252Table_kt_pkmjoq;
function _init_properties_Win1252Table_kt__tl0v64() {
  if (!properties_initialized_Win1252Table_kt_pkmjoq) {
    properties_initialized_Win1252Table_kt_pkmjoq = true;
    // Inline function 'kotlin.intArrayOf' call
    WIN1252_TABLE = new Int32Array([8364, -1, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, -1, 381, -1, -1, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, -1, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]);
  }
}
function DefaultPool(capacity) {
  this.p2u_1 = capacity;
  var tmp = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this.p2u_1;
  tmp.q2u_1 = Array(size);
  this.r2u_1 = 0;
}
protoOf(DefaultPool).s2u = function (instance) {
};
protoOf(DefaultPool).t2u = function (instance) {
  return instance;
};
protoOf(DefaultPool).u2u = function (instance) {
};
protoOf(DefaultPool).v2u = function () {
  if (this.r2u_1 === 0)
    return this.o2u();
  this.r2u_1 = this.r2u_1 - 1 | 0;
  var idx = this.r2u_1;
  var tmp = this.q2u_1[idx];
  var instance = !(tmp == null) ? tmp : THROW_CCE();
  this.q2u_1[idx] = null;
  return this.t2u(instance);
};
protoOf(DefaultPool).w2u = function (instance) {
  this.u2u(instance);
  if (this.r2u_1 === this.p2u_1) {
    this.s2u(instance);
  } else {
    var _unary__edvuaz = this.r2u_1;
    this.r2u_1 = _unary__edvuaz + 1 | 0;
    this.q2u_1[_unary__edvuaz] = instance;
  }
};
protoOf(DefaultPool).t20 = function () {
  var inductionVariable = 0;
  var last = this.r2u_1;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = this.q2u_1[i];
      var instance = !(tmp == null) ? tmp : THROW_CCE();
      this.q2u_1[i] = null;
      this.s2u(instance);
    }
     while (inductionVariable < last);
  this.r2u_1 = 0;
};
//region block: post-declaration
protoOf(Read).n2j = resume;
protoOf(Read).o2j = resume_0;
protoOf(Write).n2j = resume;
protoOf(Write).o2j = resume_0;
protoOf(ByteChannel).t2l = awaitContent$default;
protoOf(ByteReadChannel$Companion$Empty$1).t2l = awaitContent$default;
protoOf(CountedByteReadChannel).t2l = awaitContent$default;
protoOf(SourceByteReadChannel).t2l = awaitContent$default;
protoOf(DefaultPool).i3 = close;
protoOf(NoPoolImpl).i3 = close;
//endregion
//region block: init
Empty_instance = new Empty();
Companion_instance_3 = new Companion_2();
//endregion
//region block: exports
export {
  copyTo as copyTo2vm7vz7rr51or,
  readAvailable as readAvailable22vc1bmbuj93x,
  readPacket as readPacket2q2gamtzwxjd1,
  readRemaining as readRemaining1x8kk1vq7p6gm,
  readUTF8LineTo as readUTF8LineTo3cgartetbq4tk,
  readUntil as readUntil2jtfemvkt7z1f,
  skipIfFound as skipIfFound1yms04v7e3tuk,
  toByteArray as toByteArrayafjflk7yznm4,
  writeFully as writeFully3gv1ab611t04k,
  LineEndingMode__plus_impl_ttpz2j as LineEndingMode__plus_impl_ttpz2j1vdcj3ndf6qez,
  Charsets_getInstance as Charsets_getInstanceqs70pvl4noow,
  Companion_getInstance_0 as Companion_getInstance2ai11rhpust2a,
  Companion_getInstance_1 as Companion_getInstance2zbi981hww1p4,
  MalformedInputException as MalformedInputExceptionbvc6h5ij0ias,
  decode as decode1t43jmuxrxpmo,
  encode as encode35e4rpnc94tb5,
  forName as forName2faodmskqnoz5,
  isSupported as isSupported2nf870ypy50et,
  get_name as get_name2f11g4r0d5pxp,
  canRead as canRead1guo8vbveth0f,
  discard_0 as discard3ugntd47xyll6,
  readAvailable_0 as readAvailable27gpepp0hyyts,
  readText_0 as readText27783kyxjxi1g,
  get_remaining as get_remaining1lapv95kcmm0y,
  takeWhile as takeWhile34751tcfg6owx,
  toByteArray_0 as toByteArray1i3ns5jnoqlv6,
  writeFully_0 as writeFully359t6q8kam2g5,
  writeText as writeText19qfzm98fbm4l,
  get_ByteArrayPool as get_ByteArrayPool3f7yrgvqxz9ct,
  DefaultPool as DefaultPool2gb1fm4epwgu9,
  NoPoolImpl as NoPoolImplgos9n8jphzjp,
  ByteChannel as ByteChannel3cxdguezl3lu7,
  ByteReadChannel as ByteReadChannel1cb89sbyipkce,
  ByteReadChannel_1 as ByteReadChannel2wzou76jce72d,
  WriterScope as WriterScope3b0bo1enaee6b,
  cancel_0 as canceldn4b3cdqcfny,
  close_0 as close3semq7pafb42g,
  counted as counted3iniv3aql3f9n,
  invokeOnCompletion as invokeOnCompletion1ziuxzoag0iwj,
  ioDispatcher as ioDispatcher3b9pa3x0duop,
  readText as readText3frapgncbqrcg,
  writer as writer1eia5its2a1fh,
};
//endregion

//# sourceMappingURL=ktor-ktor-io.mjs.map
